import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { CoreModule } from '../core/core.module';
import { DepotStockLocationRoutingModule } from './depot-stock-location-routing.module';
import { DepotStockLocationsComponent } from './pages/depot-stock-locations/depot-stock-locations.component';
import { DepotStockLocationsNewComponent } from './pages/depot-stock-locations-new/depot-stock-locations-new.component';
import { DepotStockLocationsEditComponent } from './pages/depot-stock-locations-edit/depot-stock-locations-edit.component';
import { DepotStockLocationFormComponent } from './partials/depot-stock-location-form/depot-stock-location-form.component';

@NgModule({
  declarations: [
    DepotStockLocationsComponent,
    DepotStockLocationsNewComponent,
    DepotStockLocationsEditComponent,
    DepotStockLocationFormComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    NgSelectModule,
    DepotStockLocationRoutingModule,
  ],
})
export class DepotStockLocationModule { }
